import React, { memo } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import UploadFile from "../../ImportClientList/UploadFile"
import styles from "../ImportReport.module.css"

/**
 * Bulk Fix Tab Component
 * Provides interface for bulk fixing errors via file upload
 * Follows Single Responsibility Principle - handles bulk fix UI
 * Memoized to prevent unnecessary re-renders
 *
 * @param {Object} props - Component props
 * @param {string} props.failedRecordsUrl - URL to download failed records
 * @param {Function} props.onFileChange - Callback when file is selected
 */
const BulkFixTab = memo(({ failedRecordsUrl, onFileChange }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={styles.bulkFixContent}>
        <p className={styles.bulkFixPara}>{t("clients.import_report.bulk_fix_step1")}</p>
        <div className="mb-m">
          {t("clients.import_report.bulk_fix_step1_instruction")}
          <a href={failedRecordsUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            {t("clients.download_error_list")}
          </a>
        </div>
      </div>
      <div className={styles.bulkFixContent}>
        <p className={styles.bulkFixPara}>{t("clients.import_report.bulk_fix_step2")}</p>
        <p>{t("clients.import_report.bulk_fix_step2_instruction")}</p>
        <UploadFile handleFileChangeImport={onFileChange} />
      </div>
    </>
  )
})

BulkFixTab.displayName = "BulkFixTab"

BulkFixTab.propTypes = {
  failedRecordsUrl: PropTypes.string.isRequired,
  onFileChange: PropTypes.func.isRequired
}

export default BulkFixTab
